import { isDataKey } from "@effektify/types";
import { isMdTag, isCmsTag } from "@effektify/types/guards";
import { getChartData, isGoalsList, createTitleTranslator, getValueData, mapTrendsData } from "./cardData.js";
import { mapRowToColumns } from "./data.js";
const mapValueWithTrendProps = (config, cardData, {
  translate,
  noComparison
}) => {
  const {
    comp,
    value,
    title,
    desired_trend
  } = config.slots;
  let help = null;
  if (title?.help) {
    help = isCmsTag(title.help) ? title.help : translate(title.help);
  }
  const props = {
    title: title !== void 0 ? {
      text: translate(title.text),
      help
    } : void 0,
    original: null,
    comparison: null,
    noComparison: noComparison || !comp
  };
  const mappedData = mapRowToColumns(Object.values(cardData)[0]);
  if (mappedData && Object.keys(mappedData).length > 0 && mappedData[value.key]) {
    const original = mappedData[value.key];
    props.format = {
      short: original?.short !== false
    };
    props.original = original ?? null;
    props.comparison = noComparison || !comp ? null : {
      original: original?.value,
      comparison: mappedData[comp.key]?.value,
      desiredTrend: desired_trend ?? "positive"
    };
  }
  return props;
};
const mapGaugeProps = (config, cardData, {
  translate,
  goalsData
}) => {
  const {
    goals: configGoals
  } = config;
  const chart = config.slots.chart;
  const mappedData = mapRowToColumns(getChartData(cardData, chart));
  const goalType = configGoals && isGoalsList(configGoals) ? configGoals[0]?.key : void 0;
  const goal = goalType && goalsData ? goalsData[goalType] : void 0;
  const footerSlot = config.slots.footer;
  const footerDataKey = isDataKey(footerSlot) && typeof footerSlot.key === "string" && footerSlot.key in mappedData ? footerSlot.key : null;
  return {
    title: createTitleTranslator(translate)(config.slots.title),
    footer: {
      text: goal?.description ?? (footerDataKey ? mappedData[footerDataKey]?.value : translate(footerSlot)),
      isMarkdown: goal?.description ? false : isMdTag(footerSlot)
    },
    chart: {
      type: "semi-circle",
      data: mappedData[chart.data.key],
      description: chart.description ? mappedData[chart.description.key] : void 0,
      goal
    },
    goalType
  };
};
const mapLineChartProps = (config, cardData, {
  translate,
  noComparison,
  resolveSeriesData
}) => {
  const chartConfig = config.slots.chart;
  const chartData = getChartData(cardData, chartConfig);
  const value = isDataKey(config.slots?.value || "") ? getValueData(cardData, config.slots.value) : null;
  const {
    xAxis,
    series: seriesData
  } = resolveSeriesData(chartData, chartConfig);
  return {
    title: createTitleTranslator(translate)(config.slots.title),
    chart: {
      type: "line_chart",
      value,
      configuration: chartConfig.configuration,
      series: chartConfig.series,
      seriesData,
      xAxis,
      showLabels: chartConfig["show-labels"],
      trends: config.slots.trends && !noComparison ? mapTrendsData(cardData, config.slots.trends, translate) : void 0
    }
  };
};
export {
  mapGaugeProps,
  mapLineChartProps,
  mapValueWithTrendProps
};
